import { Controller } from "@hotwired/stimulus"

// application-settings--edit
//
// Handles the radio-driven label toggle for token lifetime type.
// AJAX form submission is delegated to the shared ajax-form controller.
export default class extends Controller {
  static targets = ["tokenLifetimeLabel"]

  updateLifetimeLabel(event) {
    if (!this.hasTokenLifetimeLabelTarget) return

    const prefix = event.target.value === "true" ? "Inactivity" : "Absolute"
    this.tokenLifetimeLabelTarget.textContent = `${prefix} lifetime (1 - 31536000)`
  }
}
